import { defaultParser } from 'utils/fhirData/parsingFunctions';

export default record => {
  const parseRecord = defaultParser(record);
  const { familyHistory } = parseRecord;
  return familyHistory || 'Family medical history was not found';
};
